if (typeof SwiperCarousel !== 'function') {
  class SwiperCarousel extends HTMLElement {
    constructor() {
      super()
      this.slideAmount = this.querySelectorAll('.swiper-slide').length
      this.swiperContainer = this.querySelector('.swiper')
      this.swiperInstance = new Swiper(this.swiperContainer, {
        loop: true,
        enabled: true,
        spaceBetween: 1,
        centerInsufficientSlidses: true,
        slidesPerView: 1.5,
        breakpoints: {
          320: {
            slidesPerView: 2.2
          },
          500: {
            slidesPerView: 2.2
          },
          768: {
            slidesPerView: 3.2
          },
          880: {
            slidesPerView: 3.2
          },
          1024: {
            slidesPerView: 4.2
          },
          1280: {
            slidesPerView: 4.2
          }
        }
      })

      this.querySelector('.prev').addEventListener('click', (event) => {
        this.swiperInstance.slidePrev()
      })

      this.querySelector('.next').addEventListener('click', (event) => {
        this.swiperInstance.slideNext()
      })
    }
  }
  if (!customElements.get('swiper-carousel')) {
    customElements.define('swiper-carousel', SwiperCarousel)
  }
}